import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ReactiveFormsModule, ControlContainer, FormGroupDirective, FormControl } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { SelectFormFieldComponent } from '../fields/select-form-field/select-form-field.component';
import { UsersService } from 'app/shared/services/users.service';
import { IUser } from 'app/shared/models/users.model';
import { Subject, take, takeUntil } from 'rxjs';
import { HelperService } from 'app/shared/services/helper.service';
import { CaseFormModel } from 'app/case-form/case-form.model';
import { SelectFormEnum } from 'app/shared/enums/select-form.enum';


@Component({
  selector: 'app-case-team-form',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    SelectFormFieldComponent,
    TranslateModule
  ],
  templateUrl: './case-team-form.component.html',
  styleUrl: './case-team-form.component.scss',
  viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }],
})
export class CaseTeamFormComponent {
  form: any;
  createdByUsers: IUser[] = [];
  ticketOwnerUsers: IUser[] = [];
  caseContactUsers: IUser[] = [];
  stcUsers: IUser[] = [];
  pcUsers: IUser[] = [];
  appsUsers: IUser[] = [];
  epartResource: IUser[] = [];
  viewMode = true;
  private destroy$ = new Subject<void>();
  @Input() caseObject!: CaseFormModel;
  @Output() onTicketOwnerChange = new EventEmitter<IUser>();

  constructor(
    public mainForm: FormGroupDirective,
    public usersService: UsersService,
    private helperService: HelperService
  ) { }

  ngOnInit(): void {
    this.createForm();
  }

  ngOnChanges() {
    if (this.caseObject) {
      this.getUsersData();
    }
  }

  createForm() {
    this.form = this.mainForm.form;

    this.form.addControl('createdById', new FormControl({ value: null, disabled: true }, []));
    this.form.addControl('ticketOwnerId', new FormControl(null, []));
    this.form.addControl('internalCaseContactId', new FormControl(null, []));
    this.form.addControl('stcResourceId', new FormControl(null, []));
    this.form.addControl('pcResourceId', new FormControl(null, []));
    this.form.addControl('appsResourceId', new FormControl(null, []));
    this.form.addControl('epartResourceId', new FormControl(null, []));
  }

  getUsersData() {
    this.usersService.users$.subscribe((users: IUser[]) => {
      this.createdByUsers = this.helperService.getUsersListWithSelectedUser(users, this.caseObject.createdById, this.caseObject.createdBy);
      this.ticketOwnerUsers = this.helperService.getUsersListWithSelectedUser(users, this.caseObject.ticketOwnerId, this.caseObject.ticketOwner);
      this.caseContactUsers = this.helperService.getUsersListWithSelectedUser(users, this.caseObject.internalCaseContactId, this.caseObject.internalCaseContact);
      this.stcUsers = this.helperService.getUsersListWithSelectedUser(users, this.caseObject.stcResourceId, this.caseObject.stcResource);
      this.pcUsers = this.helperService.getUsersListWithSelectedUser(users, this.caseObject.pcResourceId, this.caseObject.pcResource);
      this.appsUsers = this.helperService.getUsersListWithSelectedUser(users, this.caseObject.appsResourceId, this.caseObject.appsResource);
      this.epartResource = this.helperService.getUsersListWithSelectedUser(users, this.caseObject.epartResourceId, this.caseObject.epartResource);
    });
  }

  searchUsers(event: string, term: string, usersList: string, page: number = 0, take: number = 50): void {
    this.usersService
      .getUsers(term, page * take, take)
      .pipe(takeUntil(this.destroy$))
      .subscribe((res: IUser[]) => {
        if (event === SelectFormEnum.SCROLL) {
          (this as any)[usersList] = [...(this as any)[usersList], ...res];
        } else if (event === SelectFormEnum.SEARCH) {
          (this as any)[usersList] = [...res];
        }
      });
  }

  onSelectinternalCaseContact($event: any) {
    this.form.get('caseRecord').patchValue({ internalCaseContactId: $event.id });
    this.form.updateValueAndValidity();
  }

  changeTicketOwner($event: IUser) {
      this.onTicketOwnerChange.emit($event);
  }

}
